/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AgentRun,
  AgentRunContinueRequestRequest,
  AgentRunListParams,
  AgentRunProgress200,
  AgentRunRequest,
  AgentRunStartRequestRequest,
  AgentRunStartResponse,
  PaginatedAgentRunListList,
} from "../../models";

import { customInstance } from "../../custom-instance";
import type { ErrorType, BodyType } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * 사용자의 AI Agent 실행 기록 목록을 조회합니다.
 * @summary Agent 실행 목록 조회
 */
export const agentRunList = (
  params?: AgentRunListParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PaginatedAgentRunListList>(
    { url: `/api/ai-agent/runs/`, method: "GET", params, signal },
    options,
  );
};

export const getAgentRunListQueryKey = (params?: AgentRunListParams) => {
  return [`/api/ai-agent/runs/`, ...(params ? [params] : [])] as const;
};

export const getAgentRunListQueryOptions = <
  TData = Awaited<ReturnType<typeof agentRunList>>,
  TError = ErrorType<unknown>,
>(
  params?: AgentRunListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof agentRunList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAgentRunListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof agentRunList>>> = ({
    signal,
  }) => agentRunList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof agentRunList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AgentRunListQueryResult = NonNullable<
  Awaited<ReturnType<typeof agentRunList>>
>;
export type AgentRunListQueryError = ErrorType<unknown>;

export function useAgentRunList<
  TData = Awaited<ReturnType<typeof agentRunList>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | AgentRunListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof agentRunList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof agentRunList>>,
          TError,
          Awaited<ReturnType<typeof agentRunList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAgentRunList<
  TData = Awaited<ReturnType<typeof agentRunList>>,
  TError = ErrorType<unknown>,
>(
  params?: AgentRunListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof agentRunList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof agentRunList>>,
          TError,
          Awaited<ReturnType<typeof agentRunList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAgentRunList<
  TData = Awaited<ReturnType<typeof agentRunList>>,
  TError = ErrorType<unknown>,
>(
  params?: AgentRunListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof agentRunList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Agent 실행 목록 조회
 */

export function useAgentRunList<
  TData = Awaited<ReturnType<typeof agentRunList>>,
  TError = ErrorType<unknown>,
>(
  params?: AgentRunListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof agentRunList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAgentRunListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 특정 Agent 실행의 상세 정보를 조회합니다.
 * @summary Agent 실행 상세 조회
 */
export const agentRunRetrieve = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<AgentRun>(
    { url: `/api/ai-agent/runs/${id}/`, method: "GET", signal },
    options,
  );
};

export const getAgentRunRetrieveQueryKey = (id?: string) => {
  return [`/api/ai-agent/runs/${id}/`] as const;
};

export const getAgentRunRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof agentRunRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof agentRunRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAgentRunRetrieveQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof agentRunRetrieve>>
  > = ({ signal }) => agentRunRetrieve(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof agentRunRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AgentRunRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof agentRunRetrieve>>
>;
export type AgentRunRetrieveQueryError = ErrorType<unknown>;

export function useAgentRunRetrieve<
  TData = Awaited<ReturnType<typeof agentRunRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof agentRunRetrieve>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof agentRunRetrieve>>,
          TError,
          Awaited<ReturnType<typeof agentRunRetrieve>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAgentRunRetrieve<
  TData = Awaited<ReturnType<typeof agentRunRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof agentRunRetrieve>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof agentRunRetrieve>>,
          TError,
          Awaited<ReturnType<typeof agentRunRetrieve>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAgentRunRetrieve<
  TData = Awaited<ReturnType<typeof agentRunRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof agentRunRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Agent 실행 상세 조회
 */

export function useAgentRunRetrieve<
  TData = Awaited<ReturnType<typeof agentRunRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof agentRunRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAgentRunRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 진행 중인 Agent 실행을 취소합니다.
 * @summary 실행 취소
 */
export const agentRunCancel = (
  id: string,
  agentRunRequest: BodyType<AgentRunRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<AgentRun>(
    {
      url: `/api/ai-agent/runs/${id}/cancel/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: agentRunRequest,
      signal,
    },
    options,
  );
};

export const getAgentRunCancelMutationOptions = <
  TError = ErrorType<unknown | unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof agentRunCancel>>,
    TError,
    { id: string; data: BodyType<AgentRunRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof agentRunCancel>>,
  TError,
  { id: string; data: BodyType<AgentRunRequest> },
  TContext
> => {
  const mutationKey = ["agentRunCancel"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof agentRunCancel>>,
    { id: string; data: BodyType<AgentRunRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return agentRunCancel(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AgentRunCancelMutationResult = NonNullable<
  Awaited<ReturnType<typeof agentRunCancel>>
>;
export type AgentRunCancelMutationBody = BodyType<AgentRunRequest>;
export type AgentRunCancelMutationError = ErrorType<unknown | unknown>;

/**
 * @summary 실행 취소
 */
export const useAgentRunCancel = <
  TError = ErrorType<unknown | unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof agentRunCancel>>,
      TError,
      { id: string; data: BodyType<AgentRunRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof agentRunCancel>>,
  TError,
  { id: string; data: BodyType<AgentRunRequest> },
  TContext
> => {
  const mutationOptions = getAgentRunCancelMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 
        수동 승인 대기 상태(AWAITING_APPROVAL)인 Agent 실행을 계속합니다.

        선택된 아이디어 ID를 지정하면 해당 아이디어로 플레이리스트 생성을 시작합니다.
        
 * @summary 수동 승인 후 계속
 */
export const agentRunContinue = (
  id: string,
  agentRunContinueRequestRequest: BodyType<AgentRunContinueRequestRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<AgentRun>(
    {
      url: `/api/ai-agent/runs/${id}/continue/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: agentRunContinueRequestRequest,
      signal,
    },
    options,
  );
};

export const getAgentRunContinueMutationOptions = <
  TError = ErrorType<unknown | unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof agentRunContinue>>,
    TError,
    { id: string; data: BodyType<AgentRunContinueRequestRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof agentRunContinue>>,
  TError,
  { id: string; data: BodyType<AgentRunContinueRequestRequest> },
  TContext
> => {
  const mutationKey = ["agentRunContinue"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof agentRunContinue>>,
    { id: string; data: BodyType<AgentRunContinueRequestRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return agentRunContinue(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AgentRunContinueMutationResult = NonNullable<
  Awaited<ReturnType<typeof agentRunContinue>>
>;
export type AgentRunContinueMutationBody =
  BodyType<AgentRunContinueRequestRequest>;
export type AgentRunContinueMutationError = ErrorType<unknown | unknown>;

/**
 * @summary 수동 승인 후 계속
 */
export const useAgentRunContinue = <
  TError = ErrorType<unknown | unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof agentRunContinue>>,
      TError,
      { id: string; data: BodyType<AgentRunContinueRequestRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof agentRunContinue>>,
  TError,
  { id: string; data: BodyType<AgentRunContinueRequestRequest> },
  TContext
> => {
  const mutationOptions = getAgentRunContinueMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Agent 실행의 현재 진행 상황을 조회합니다.
 * @summary 진행 상황 조회
 */
export const agentRunProgress = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<AgentRunProgress200>(
    { url: `/api/ai-agent/runs/${id}/progress/`, method: "GET", signal },
    options,
  );
};

export const getAgentRunProgressQueryKey = (id?: string) => {
  return [`/api/ai-agent/runs/${id}/progress/`] as const;
};

export const getAgentRunProgressQueryOptions = <
  TData = Awaited<ReturnType<typeof agentRunProgress>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof agentRunProgress>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAgentRunProgressQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof agentRunProgress>>
  > = ({ signal }) => agentRunProgress(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof agentRunProgress>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AgentRunProgressQueryResult = NonNullable<
  Awaited<ReturnType<typeof agentRunProgress>>
>;
export type AgentRunProgressQueryError = ErrorType<unknown>;

export function useAgentRunProgress<
  TData = Awaited<ReturnType<typeof agentRunProgress>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof agentRunProgress>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof agentRunProgress>>,
          TError,
          Awaited<ReturnType<typeof agentRunProgress>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAgentRunProgress<
  TData = Awaited<ReturnType<typeof agentRunProgress>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof agentRunProgress>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof agentRunProgress>>,
          TError,
          Awaited<ReturnType<typeof agentRunProgress>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAgentRunProgress<
  TData = Awaited<ReturnType<typeof agentRunProgress>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof agentRunProgress>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 진행 상황 조회
 */

export function useAgentRunProgress<
  TData = Awaited<ReturnType<typeof agentRunProgress>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof agentRunProgress>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAgentRunProgressQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 
        AI Agent 자율 플레이리스트 생성을 시작합니다.

        **워크플로우**:
        1. YouTube 트렌드 분석
        2. Claude 기반 아이디어 생성
        3. 아이디어 자동/수동 승인
        4. WF1 연동 플레이리스트 생성
        5. YouTube 설명 생성

        **파라미터**:
        - auto_approve: True면 품질 임계값 이상 아이디어 자동 승인
        - quality_threshold: 자동 승인 기준 점수 (1.0-10.0)
        
 * @summary 자율 생성 시작
 */
export const agentRunStart = (
  agentRunStartRequestRequest: BodyType<AgentRunStartRequestRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<AgentRunStartResponse>(
    {
      url: `/api/ai-agent/runs/start/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: agentRunStartRequestRequest,
      signal,
    },
    options,
  );
};

export const getAgentRunStartMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof agentRunStart>>,
    TError,
    { data: BodyType<AgentRunStartRequestRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof agentRunStart>>,
  TError,
  { data: BodyType<AgentRunStartRequestRequest> },
  TContext
> => {
  const mutationKey = ["agentRunStart"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof agentRunStart>>,
    { data: BodyType<AgentRunStartRequestRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return agentRunStart(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AgentRunStartMutationResult = NonNullable<
  Awaited<ReturnType<typeof agentRunStart>>
>;
export type AgentRunStartMutationBody = BodyType<AgentRunStartRequestRequest>;
export type AgentRunStartMutationError = ErrorType<unknown>;

/**
 * @summary 자율 생성 시작
 */
export const useAgentRunStart = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof agentRunStart>>,
      TError,
      { data: BodyType<AgentRunStartRequestRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof agentRunStart>>,
  TError,
  { data: BodyType<AgentRunStartRequestRequest> },
  TContext
> => {
  const mutationOptions = getAgentRunStartMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
